function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "4",
  viewBox: "0 0 16 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#12002D"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "1.778",
  cy: "1.778",
  r: "1.778"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "1.778",
  r: "1.778"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "14.222",
  cy: "1.778",
  r: "1.778"
}))));